<template>
    <v-container v-resize="onResize">
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading" />
        <template v-if="!loading">
            <v-layout row wrap>
                <v-flex sm4 offset-sm2>
                    <count-up :endVal="averageServiceCount" text="Mean years of service" />
                </v-flex>
                <v-flex sm4 pb-xs-4>
                    <count-up :endVal="modeServiceCount" text="Mode years of service" />
                </v-flex>
            </v-layout>
            <br />
            <v-layout row wrap>
                <div class="d-inline">
                    <statistical-member-or-senator-selector :value="selectedMpOrSenator" @input="selectedMpOrSenator = $event" />
                </div>
                <div class="d-inline ml-3">
                    <v-btn-toggle v-model="SELECTED_GENDER" class="transparent handbook_toggleButton" @change="FILTER_GENDER" :multiple="true">
                        <v-btn class="handbook_button" :value="Gender[0]" color="secondary">
                            <span class="long-button-text">Women</span>
                        </v-btn>
                        <v-btn class="handbook_button" :value="Gender[1]" color="secondary">
                            <span class="long-button-text">Men</span>
                        </v-btn>
                    </v-btn-toggle>
                </div>
            </v-layout>
            
            <br/>
            <v-data-table
                :headers="headers" 
                :items="over20YearsItems"
                :rows-per-page-items="rowsPerPageItems"
                :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                :hide-headers="isMobile"
                :disable-initial-sort="true"
                :loading="loading">
                <template v-slot:items="props">
                    <template v-if="isMobile">
                            <tr>
                                <td>
                                    <div class="flex-content">
                                        
                                        <div class="flex-item flex-item-col flex-item-col-30">
                                            <div class="flex-item">
                                                <Portrait v-bind:PHID="props.item.Phid" :fixedWidth="80"></Portrait>
                                            </div>
                                        </div>
                                        <div class="flex-item flex-item-col flex-item-col-70">
                                            <div class="flex-item">
                                                <h3 class="pb-xs-1"><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}">{{ props.item.DisplayName }}</router-link></h3>
                                            </div>
                                            <div class="flex-item" data-label="Years/months">
                                                {{ props.item.Duration.replace(' 0 months', '') }}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    <template v-if="!isMobile">
                        <td class="text-xs-left">
                            <Portrait v-bind:fixedWidth="80" v-bind:PHID="props.item.Phid"></Portrait>
                        </td>
                        <td class="text-xs-left"><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}">{{ props.item.DisplayName }}</router-link></td>
                        
                        <td class="text-xs-left"> {{ props.item.Chamber }}</td>
                        <td class="text-xs-left"> {{ props.item.Gender }}</td>
                        <td class="text-xs-left"> {{ props.item.State }}</td>
                        <td class="text-xs-left"> {{ props.item.Duration.replace(' 0 months', '') }}</td>
                    </template>
                </template>
            </v-data-table>
            <br/>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download as CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout>            
        </template>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import StatisticalMemberOrSenatorSelector from './StatisticalMemberOrSenatorSelector.vue';
import Portrait from '@/components/Portrait.vue'
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;
import CountUp from './CountUp.vue';
import { mode } from '../../functions/average';
import orderBy from 'lodash.orderby';

export default {
    created() {
        this.initialiseItems();
    },
    components: {
        Loader,
        StatisticalHeader,
        StatisticalMemberOrSenatorSelector,
        CountUp,
        Portrait,
    },
    methods: {
        initialiseItems() {
            this.loading = true;
            const parliamentarianType = this.selectedMpOrSenator.length == 0 || this.selectedMpOrSenator.length == 2 ?
                '' : this.selectedMpOrSenator[0];
            const url = `StatisticalInformation/LongestServingMembers?parliamentariantype=${parliamentarianType}&all=false`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.items = response.data;
                    this.itemsBackup = response.data;
                    this.loading = false;
                });
        },
        filterMpOrSenator() {
            this.initialiseItems();
        },
        handleStateClick(stateId) {
            const query = {
                "logicalOperator":"all",
                "children":[
                    {"type":"query-builder-rule", "query":{"rule":"inCurrentParliament","selectedOperand":"In current Parliament","value":"Yes"}}
                ]};
            if (stateId) {
                query.children.push({"type":"query-builder-rule","query":{"rule":"state","selectedOperator":"of","selectedOperand":"State","value":stateId}});
            }
            this.handleParliamentarianType(query);
            localStorage.query = JSON.stringify(query);    
            this.$router.push('/AdvancedSearch');
        },
        handleParliamentarianType(query) {
            if (this.selectedMpOrSenator.length == 1) {
                const selected = this.selectedMpOrSenator[0];
                switch (selected) {
                    case 'senator':
                        query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"senator"}});
                        break;
                    case 'mp':
                        query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"member"}});
                }
            }
        },
        FILTER_GENDER: function () {
            if (this.SELECTED_GENDER && this.SELECTED_GENDER.length == 1) {
                this.items = this.itemsBackup.filter(i => i.Gender == this.SELECTED_GENDER[0]);
            }
            else {
                this.items = this.itemsBackup;
            }
        },
        exportCsv: function () {
            this.csvDownloading = true;
            const records = this.items.map(i => 
                ({ 
                    Phid: i.Phid,
                    Parliamentarian: i.DisplayName,
                    'Chamber': i.Chamber,
                    'Gender': i.Gender,
                    'State': i.State,
                    'Years/months': i.Duration,
                    'Total days': i.DurationInDays,
                }));
            let headers = this.headers.map(h => h.text);
            const filename = this.title;
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        },
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },   
    },
    computed: {
        csvDownloadIcon(){
            return this.csvDownloading ? 'cached' : 'text_snippet';
        },
        csvDownloadClass(){
            let csvClass = 'mr-1';
            if (this.csvDownloading){
                csvClass = csvClass + ' loading'
            }
            return csvClass;
        },
        over20YearsItems() {
            return this.items.filter(i => i.DurationInDays / 365.2425 > 20)
        },
        averageServiceCount() {
            const avgDays = this.items.reduce((a,b) => a + b.DurationInDays, 0) / this.items.length;
            return avgDays / 365.2425                
        },
        modeServiceCount() {
            const years = this.items
                .map(i => Math.trunc(i.DurationInDays / 365.2425))
                const modeYears = mode(years);
                return modeYears;
        },
        chartData() {
            let parties = [...new Set(this.over20YearsItems.map(p => p.PartyName))];
            parties = orderBy(parties, [p => this.over20YearsItems.filter(i => i.PartyName === p).length], ['desc'])

            return {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: 'Longest serving members (over 20 years) by party'
                },
                xAxis: {
                    categories: parties
                },
                yAxis: {
                    title: {
                        text: ''
                    }
                },
                series: [{
                    name: 'Parliamentarians',
                    data: parties
                    .map(p => ({ 
                        y: this.over20YearsItems.filter(i => i.PartyName === p).length,
                        color: this.over20YearsItems.find(i => i.PartyName === p).PartyColour })),
                }] 
            }
        }
    },    
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
        }
    },
    mounted() {
        this.onResize();
    },
    data() {
        return {
        title: 'Longest serving members (over 20 years)',
        isMobile: false,
        headers: [
             {
                text: 'Photo',
                value: 'DisplayName',
                sortable: false,
                width: '100px'
            },
            {
                text: 'Parliamentarian',
                value: 'DisplayName' 
            },
            {
                text: 'Chamber',
                value: 'Chamber'
            },
            {
                text: 'Gender',
                value: 'Gender'
            },
            {
                text: 'State',
                value: 'State'
            },
            {
                text: 'Years/months',
                value: 'DurationInDays'
            }
        ],
        items: [],
        itemsBackup: [],
        Gender: ['Woman', 'Man'],
        SELECTED_GENDER: ['Woman', 'Man'],
        search: '',
        loading: true,
        csvDownloading: false,
        selectedMpOrSenator: ['senator', 'mp'],
        memberOrSenator: 'member',
        rowsPerPageItems: [ 10, 25, {
            "text": "$vuetify.dataIterator.rowsPerPageAll",
            "value": -1
            }]
        }
    }
}
</script>
<style scoped>
    a {
        text-decoration: none;
    }
</style>